import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { globalTheme } from '@cld/component-theme';
import { overrides } from '@cld/button';

const { Button } = overrides.mediaLibraryWidgetDemoOverrides;

export interface TabProps {
  id: string,
  children?: ReactNode;
  selected?: boolean,
  onClick: () => void;
}

/* todo: It's bad solution but primary variant and secondary is already taken so there seems to be no other way. */
const ColoredButton = styled(Button)`
  background: transparent;
  color: ${globalTheme.palette.brand.darkBlue};
  border: solid 1px ${globalTheme.palette.secondary};
  padding: ${globalTheme.spacing.sm} ${globalTheme.spacing.xxl};
  
  &:hover, &.selected, &:focus {
    background-color: ${globalTheme.palette.brand.darkBlue} !important;
    color: ${globalTheme.palette.contrastInvert}
  }
`;

export const Tab: FC<TabProps> = ({ id, children, selected, onClick }) => (
  <ColoredButton
    id={id}
    shape="pill"
    selected={selected}
    onClick={onClick}
    aria-controls={`${id}-view`}
    data-test={`tabs-section-${id}-tab`}
  >
    {children}
  </ColoredButton>
);
